import { useCallback, useState } from 'react'
import { Damage } from '../../constants'

const useDamageDataQuery = () => {
  const [isOpenedDamageDetailsWindow, setIsOpenedDamageDetailsWindow] =
    useState(false)
  const [damageData, setDamageData] = useState({})

  const getDamageData = useCallback((damage: Damage | null) => {
    if (damage) {
      setDamageData(damage)
      setIsOpenedDamageDetailsWindow(true)
    }
  }, [])

  const handleDamageDetailsWindowClose = () =>
    setIsOpenedDamageDetailsWindow(false)

  return {
    isOpenedDamageDetailsWindow,
    damageData,
    handleDamageDetailsWindowClose,
    getDamageData,
  }
}

export default useDamageDataQuery
